import { AlertPriority, PriorityConfig } from '../models/alert';

/** The config for `priority`, or null when it is missing or unrecognised. */
export function findPriorityConfig(
  configs: PriorityConfig[],
  priority: AlertPriority | undefined,
): PriorityConfig | null {
  return configs.find((config) => config.id === priority) ?? null;
}
